// context/AppContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { checkCode, get_cfg } from "./api/apis";
import { setSidGetter } from "./api/srs";


const AppContext = createContext();
export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children, restaurant }) => {
    const [cfg, setCfgState] = useState(null);
    const [auth, setAuthState] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkRestaurant = () => {
        if (cfg && restaurant && cfg.uid !== restaurant) {
            setCfg(null)
        }
    };

    useEffect(() => {
        checkRestaurant();
    }, [cfg, restaurant]);


    useEffect(() => {
      const init = async () => {
        // Step 1: Setup cfg
        const storedCfg = localStorage.getItem("cfg");
        let cfgValue;
      
        if (storedCfg && storedCfg !== "undefined") {
          try {
            cfgValue = JSON.parse(storedCfg);
            setCfgState(cfgValue);
          } catch (e) {
            console.error("Error parsing cfg from localStorage:", e);
            localStorage.removeItem("cfg");
          }
        }
      
        if (!cfgValue) {
          cfgValue = await get_cfg(restaurant);
          setCfgState(cfgValue);
          localStorage.setItem("cfg", JSON.stringify(cfgValue));
        }
      
        // Step 2: Set sid *before* calling checkCode
        if (cfgValue?.sid) {
          setSidGetter(() => cfgValue.sid);
        }
      
        // Step 3: Validate auth only after sid is set
        const storedAuth = localStorage.getItem("auth");
        if (storedAuth && storedAuth !== "undefined") {
          try {
            const parsedAuth = JSON.parse(storedAuth);
            if(!parsedAuth){
              localStorage.removeItem("auth");
            }
            const result = await checkCode(parsedAuth?.phone, parsedAuth?.code);
            if (result.ok) {
              setAuthState(parsedAuth);
            } else {
              console.warn("Stored auth code was invalid");
              localStorage.removeItem("auth");
              setAuthState(null);
            }
          } catch (e) {
            console.error("Error parsing auth from localStorage:", e);
            localStorage.removeItem("auth");
            setAuthState(null);
          }
        }
      
        setLoading(false);
      };
      
      
      init();
    }, [restaurant]);
  
    const getAuth = async () => {
      if (auth?.phone && auth?.code) {
        const response = await checkCode(auth?.phone, auth?.code);
        if (response.ok) return auth;
      }
      setAuth(null);
      return null;
    };
  
    const getCfg = async () => {
      if (cfg) return cfg;
      console.log(restaurant)
      const res = await get_cfg(restaurant);
      setCfg(res);
      return res;
    };

    useEffect(() => {
        if (cfg?.sid) {
          setSidGetter(() => cfg.sid); // ✅ This will be used by srs.sio_req()
        }
      }, [cfg]);
  
    const setCfg = (val) => {
      setCfgState(val);
      if(val == null)localStorage.removeItem("cfg");
      else{
          localStorage.setItem("cfg", JSON.stringify(val));
      }

    };
  
    const setAuth = (val) => {
      setAuthState(val);
      localStorage.setItem("auth", JSON.stringify(val));
    };

    const table = cfg?.bord;

    const setTable = (tableValue) => {
      const updatedCfg = { ...cfg, bord: tableValue };
      setCfg(updatedCfg); // already saves to localStorage
    };

    
  
    // sid getter (sync-style usage)
    const sid = cfg?.sid;
  
    if (loading) return null; // or return a <Loader />
  
    return (
      <AppContext.Provider
        value={{
          cfg,
          sid,
          setCfg,
          getCfg,
          table,
          setTable,
          auth,
          setAuth,
          getAuth,
        }}
      >
        {children}
      </AppContext.Provider>
    );
  };
  
